import React, { useRef, useEffect, useState } from 'react';
import { useDispatch } from 'react-redux';
import countriesList from 'iso-3166-1-alpha-2';
import { RegexFields } from '../../../../../../constants/utils/regexFields';
import * as R from 'ramda';
import $ from 'jquery';
import * as loadings from '../../../../../../constants/loadings/facilita/deathDeclaration';
import {createServiceData, updateServiceData, deleteServiceData} from '../../../../../../actions/facilita-api';
import {ConnectionTypes} from '../../../../../../constants/utils/connectionTypes';
import { updateDeathDeclaration } from './../../../../../../actions/facilita-api';

import { PostalCityInput } from "../../../../../../_common/postalCityInput";



export const ModalActivitySection = ({activity, initCollapsedState, index, isLoading, removeFromList, deathDeclaration}) => {
    const dispatch = useDispatch();
    var countries = require("i18n-iso-countries");
    countries.registerLocale(require("i18n-iso-countries/langs/fr.json"));
    let initState = {
        ...activity.payload
    };
    initCollapsedState = R.isNil(activity.collapsed) ? initCollapsedState : activity.collapsed;

    const activityForm = useRef(null);
    const [wasValidated, setWasValidated] = useState(false);
    const [payload, setPayload] = useState(initState);
    const [collapsed, setCollapsed] = useState(initCollapsedState);

    let hasCompanySavingsPlanReference = false;
    if (!R.isNil(payload.companySavingsPlanReference) && payload.companySavingsPlanReference !== "") {
        hasCompanySavingsPlanReference = true;
    }

    const [showSavings, setShowSavings] = useState(hasCompanySavingsPlanReference);
    const [showAccident, setShowAccident] = useState(deathDeclaration.diedInActivityId === activity.id);

    useEffect(() => {
        $('[data-toggle="tooltip"]').tooltip();
    }, []);
    
    return (
			<section className={"block mb-3"} id={"activity_" + index}>
				<div className="card-header p-0 mb-3" id={"activity_" + index + "_heading"} role="button" onClick={() => setTimeout(() => setCollapsed(!collapsed), 200)}>
					<div className="flex-row align-items-center justify-content-lg-between" data-toggle="collapse" data-target={"#ModalActivitySection_" + index} aria-expanded={!collapsed} aria-controls={"#ModalActivitySection_" + index}>
						<h4 className="h3 font-weight-black container-tight my-auto">{index === 0 ? "Activité principale" : "Autre activité"}</h4>
						{!R.isNil(payload.companyName) ? (
							<span className="mr-auto align-middle">
								<i className="eva eva-arrow-right mx-2 align-middle o-30"></i>
								<span className="o-60 align-middle">{payload.companyName}</span>
							</span>
						) : (
							""
						)}
						<button type="button" className="btn btn-icon p-0 text-uppercase font-weight-demi fs-4 my-auto ml-auto m-lg-1 o-40" name="refPrincipal">
							<i className={"eva " + (!collapsed ? "eva-arrow-ios-upward-outline" : "eva-arrow-ios-downward-outline")}></i>
						</button>
					</div>
				</div>
				<div className={"collapse" + (collapsed ? " show" : "")} id={"ModalActivitySection_" + index} aria-labelledby={"activity_" + index + "_heading"} data-parent={"#activity_" + index}>
					<form className="block" noValidate ref={activityForm}>
						<h5 className="h4 text-uppercase text-secondary font-weight-black mb-sm">nom de l’entreprise</h5>
						<div className="row gx-2 mt-n2">
							<div className="col-12 col-md-5">
								<div className="form-group">
									<label className="h6 font-weight-bolder my-auto" htmlFor={"companyName"}>
										Nom de l’entreprise
									</label>
									<input
										required
										type="text"
										className="form-control"
										id={"companyName"}
										placeholder="Entreprise"
										defaultValue={payload.companyName}
										onChange={(event) => {
											setPayload({ ...payload, companyName: event.target.value });
										}}
									/>
									<div className={"invalid-feedback" + (payload.companyName === undefined && wasValidated === true ? " show" : "")}>
										<i className="eva eva-alert-triangle-outline text-warning mr-1 fs-sm lh-root align-middle"></i>
										<span className="align-middle text-dark o-70">Ce champ est requis</span>
									</div>
								</div>
							</div>
							<div className="col-12 col-md-7">
								<div className="form-group">
									<div className="flex-row gx-2 align-items-center mb-1">
										<label className="h6 font-weight-bolder my-auto" htmlFor={"Adresseentreprise"}>
											Adresse ligne 1
										</label>
										<p
											className="form-text small text-gray my-auto ml-auto"
											data-toggle="tooltip"
											data-placement="top"
											data-html="true"
											data-template='<div class="tooltip" role="tooltip"><div class="arrow"></div><div class="tooltip-inner px-3 py-2 fs-2"></div></div>'
											title="L'adresse de l'organisme est nécessaire afin de pouvoir le contacter et d'effectuer les démarches.">
											<i className="eva eva-info-outline mr-1 fs-sm lh-root align-middle"></i>
										</p>
									</div>
									<input
										required
										type="text"
										className="form-control"
										id={"Adresseentreprise"}
										placeholder="Adresse de l'entreprise"
										defaultValue={payload.companyAddressStreet1}
										onChange={(event) => {
											setPayload({ ...payload, companyAddressStreet1: event.target.value });
										}}
									/>
									<div className="invalid-feedback">
										<i className="eva eva-alert-triangle-outline text-warning mr-1 fs-sm lh-root align-middle"></i>
										<span className="align-middle text-dark o-70">Ce champ est requis</span>
									</div>
								</div>
								<div className="form-group">
									<label className="label h6 font-weight-bold my-auto" htmlFor={"Adresseligne2"}>
										Adresse ligne 2
									</label>
									<input
										type="text"
										className="form-control rounded"
										id={"Adresseligne2"}
										placeholder="(optionnel)"
										value={payload.companyAddressStreet2}
										onChange={(event) => {
											setPayload({ ...payload, companyAddressStreet2: event.target.value });
										}}
									/>
								</div>
								<div className="form-row">
									<PostalCityInput
										postalCode={payload.companyAddressPostalCode}
										city={payload.companyAddressLocality}
										onChange={(updatedAddress) => setPayload({ ...payload, companyAddressPostalCode: updatedAddress.postalCode, companyAddressLocality: updatedAddress.city })}
										hasWrapper={false}
										country={payload.companyAddressCountry}
										customClasses={{ city: "form-group col-12 col-sm-6 col-lg", postalCode: "form-group col-12 col-sm-6 col-lg" }}
									/>
									{/* <div className="form-group col-12 col-sm-6 col-lg">
										<label className="h6 font-weight-bolder my-auto" htmlFor={"Postalentreprise"} required>
											Code Postal
										</label>
										{payload.companyAddressCountry === null || payload.companyAddressCountry === "FR" || payload.companyAddressCountry === "GF" || payload.companyAddressCountry === "PF" || payload.companyAddressCountry === "TF" ? (
											<input
												required
												type="text"
												className="form-control"
												id={"Postalentreprise"}
												placeholder="ex: 75001"
												value={payload.companyAddressPostalCode}
												onChange={(event) => {
													setPayload({ ...payload, companyAddressPostalCode: event.target.value });
												}}
												pattern={RegexFields.frenchZipCode}
											/>
										) : (
											<input
												required
												type="text"
												className="form-control"
												id={"Postalentreprise"}
												placeholder="ex: 75001"
												value={payload.companyAddressPostalCode}
												onChange={(event) => {
													setPayload({ ...payload, companyAddressPostalCode: event.target.value });
												}}
											/>
										)}
										<div className="invalid-feedback">
											<i className="eva eva-alert-triangle-outline text-warning mr-1 fs-sm lh-root align-middle"></i>
											<span className="align-middle text-dark o-70">Ce champ est requis</span>
										</div>
									</div>
									<div className="form-group col-12 col-sm-6 col-lg">
										<label className="h6 font-weight-bolder my-auto" htmlFor={"Villeentreprise"} required>
											Ville
										</label>

										<input
											required
											type="text"
											className="form-control"
											id={"Villeentreprise"}
											placeholder="ex: Paris"
											defaultValue={payload.companyAddressLocality}
											onChange={(event) => {
												setPayload({ ...payload, companyAddressLocality: event.target.value });
											}}
											pattern={RegexFields.nameWithoutNumbers}
										/>
										<div className="invalid-feedback">
											<i className="eva eva-alert-triangle-outline text-warning mr-1 fs-sm lh-root align-middle"></i>
											<span className="align-middle text-dark o-70">Ce champ est requis</span>
										</div>
									</div> */}
									<div className="form-group col-12 col-sm-6 col-lg">
										<label className="h6 font-weight-bolder my-auto" htmlFor={"Paysentreprise"}>
											Pays
										</label>
										<select
											className="custom-select"
											id={"Paysentreprise"}
											tabIndex={-98}
											value={payload.companyAddressCountry}
											onChange={(event) => {
												setPayload({ ...payload, companyAddressCountry: event.target.value });
											}}>
											{Object.keys(countriesList.getData()).map((country, index) => {
												return (
													<option key={index} value={country}>
														{countries.getName(country, "fr", { select: "official" })}
													</option>
												);
											})}
										</select>
									</div>
								</div>
							</div>
						</div>
						<hr className="mb-4" />
						<h5 className="h4 text-uppercase text-secondary font-weight-black mb-sm">statut professionnel</h5>
						<div className="row gx-2 mt-n2">
							<div className="col-12 col-md">
								<div className="form-group">
									<label className="h6 font-weight-bolder my-auto" htmlFor={"poste"}>
										Intitulé du poste
									</label>
									<input
										type="text"
										className="form-control rounded"
										id={"poste"}
										placeholder="(optionnel)"
										defaultValue={payload.function}
										onChange={(event) => {
											setPayload({ ...payload, function: event.target.value });
										}}
									/>
									<div className="invalid-feedback">
										<i className="eva eva-alert-triangle-outline text-warning mr-1 fs-sm lh-root align-middle"></i>
										<span className="align-middle text-dark o-70">Ce champ est requis</span>
									</div>
								</div>
							</div>
							<div className="col-12 col-md">
								<div className="form-group">
									<label className="h6 font-weight-bolder my-auto" htmlFor={"contrat"}>
										Type du contrat
									</label>
									<select
										className="custom-select"
										id={"contrat"}
										value={payload.contractType}
										onChange={(event) => {
											setPayload({ ...payload, contractType: event.target.value });
										}}>
										<option value="CDD">CDD</option>
										<option value="CDI">CDI</option>
										<option value="Trial">Autre</option>
									</select>
								</div>
							</div>
						</div>
						<hr className="mb-4" />
						<div className="grid grid-md-2 align-items-center mb-sm">
							<h5 className="h4 text-uppercase text-secondary font-weight-black my-auto">Plan d'épargne entreprise</h5>
							<div className="custom-control custom-switch ml-md-auto">
								<input type="checkbox" className="custom-control-input" id={"showSavingsInput"} checked={showSavings} onChange={() => setShowSavings(!showSavings)} />
								<label className="custom-control-label" htmlFor={"showSavingsInput"}>
									{showSavings ? "Oui" : "Non"}
								</label>
							</div>
						</div>
						{showSavings ? (
							<div className="row gx-2 mt-n2">
								<div className="col-12 col-md">
									<div className="form-group">
										<div className="flex-row gx-2 align-items-center mb-1">
											<label className="h6 font-weight-bolder my-auto" htmlFor={"companySavingsPlanInput"}>
												Référence
											</label>
											<p
												className="form-text small text-gray my-auto ml-auto"
												data-toggle="tooltip"
												data-placement="top"
												data-html="true"
												data-template='<div class="tooltip" role="tooltip"><div class="arrow"></div><div class="tooltip-inner px-3 py-2 fs-2"></div></div>'
												title="Une référence permet à vos organismes de vous identifier afin de faire les démarches nécessaires.">
												<i className="eva eva-info-outline mr-1 fs-sm lh-root align-middle"></i>
											</p>
										</div>
										<input type="text" className="form-control" id={"companySavingsPlanInput"} value={payload.companySavingsPlanReference} onChange={(e) => setPayload({ ...payload, companySavingsPlanReference: e.target.value })} />
										<div className="invalid-feedback">
											<i className="eva eva-alert-triangle-outline text-warning mr-1 fs-sm lh-root align-middle"></i>
											<span className="align-middle text-dark o-70">Ce champ est requis</span>
										</div>
									</div>
								</div>
							</div>
						) : (
							""
						)}
						<hr className="mb-4" />
						<div className="grid grid-md-3 align-items-center mb-sm">
							<h5 className="fs-3 o-70 text-uppercase font-weight-black grid-column-md-2 my-auto">DÉCÈS SUITE À UN ACCIDENT DE TRAVAIL</h5>
							<div className="flex-row ml-md-auto">
								<div className="custom-control custom-switch ml-md-auto">
									<input type="checkbox" className="custom-control-input" id={"showAccidentInput"} checked={showAccident} onChange={() => setShowAccident(!showAccident)} />
									<label className="custom-control-label" htmlFor={"showAccidentInput"}>
										{showAccident ? "Oui" : "Non"}
									</label>
								</div>
							</div>
						</div>
						<hr className="my-0" />
						<div className="card-footer text-right px-0">
							{isLoading.includes(loadings.UPDATING_USER_SERVICES_DATA + "_" + activity.id) || isLoading.includes(loadings.CREATING_USER_SERVICES_DATA + "_" + activity.serviceId) || isLoading.includes(loadings.UPDATING_DECLARATION) ? (
								<button type="button" className="btn btn-info loading-btn show">
									<div className="loading loading-spinner spinner-border spinner-border-sm mr-2"></div>Sauvegarder
								</button>
							) : (
								<button
									type="button"
									className="btn btn-info"
									onClick={(e) => {
										e.preventDefault();
										activityForm.current.classList.add("was-validated");
										if (activityForm.current.checkValidity()) {
											if (R.isNil(activity.id) || activity.id === "") {
												dispatch(
													createServiceData({
														...activity,
														payload: payload,
													})
												).then(() => setCollapsed(!collapsed));
											} else {
												dispatch(
													updateServiceData({
														...activity,
														payload: payload,
													})
												)
													.then(() => {
														dispatch(updateDeathDeclaration(deathDeclaration.userId, { ...deathDeclaration, diedInActivityId: showAccident ? activity.id : null }));
													})
													.then(() => setCollapsed(!collapsed));
											}
											setCollapsed(!collapsed);
										}
									}}>
									Enregistrer
								</button>
							)}
							<button
								className="btn btn-sm btn-icon px-xs btn-alert-danger ml-1 border-none"
								id="basic-addon2"
								onClick={(e) => {
									e.preventDefault();
									if (R.isNil(activity.id)) {
										removeFromList(index);
									} else {
										dispatch(deleteServiceData(activity.id, ConnectionTypes.activity));
									}
								}}>
								<i className="eva eva-trash-outline"></i>
							</button>
						</div>
					</form>
				</div>
			</section>
		);
};